import { Fab, IconButton, useTheme } from '@material-ui/core';
import AssistantIcon from '@material-ui/icons/Assistant';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useRef } from 'react';
import { Composer } from './Composer';
import { ContextBar } from './ContextBar';
import { ErrorState } from './ErrorState';
import { LoadingState } from './LoadingState';
import { MessageList } from './MessageList';
import './AiAssistant.css';
export const AiAssistantPanel = ({ context, isOpen, isReplying, messages, name, onClose, onOpen, onRetry, onSend, sessionId, showTypingIndicator, status }) => {
    const theme = useTheme();
    const panelRef = useRef(null);
    const composerRef = useRef(null);
    // The panel stays mounted to animate, so mark it inert while closed (CSS
    // `visibility: hidden` covers browsers without `inert` support) and focus
    // the composer when it opens ready.
    useEffect(() => {
        if (panelRef.current) {
            panelRef.current.inert = !isOpen;
        }
        if (isOpen && status === 'ready') {
            composerRef.current?.focus();
        }
    }, [isOpen, status]);
    return (React.createElement(React.Fragment, null,
        !isOpen && (React.createElement("div", { className: "ai-assistant__fab", style: { zIndex: theme.zIndex.drawer } },
            React.createElement(Fab, { "aria-controls": "ai-assistant-panel", "aria-expanded": isOpen, "aria-label": `Open ${name}`, color: "primary", onClick: onOpen },
                React.createElement(AssistantIcon, null)))),
        React.createElement("aside", { className: `ai-assistant__panel ${isOpen ? 'ai-assistant__panel--open' : ''}`, "data-session-id": sessionId ?? undefined, id: "ai-assistant-panel", ref: panelRef, style: { zIndex: theme.zIndex.drawer } },
            React.createElement("header", { className: "ai-assistant__header" },
                React.createElement("span", { className: "ai-assistant__title" }, name),
                React.createElement(IconButton, { "aria-label": `Close ${name}`, className: "ai-assistant__close", onClick: onClose },
                    React.createElement(CloseIcon, null))),
            status === 'loading' && React.createElement(LoadingState, null),
            status === 'error' && React.createElement(ErrorState, { onRetry: onRetry }),
            status === 'ready' && (React.createElement(React.Fragment, null,
                React.createElement(ContextBar, { context: context }),
                React.createElement(MessageList, { isReplying: isReplying, messages: messages, showTypingIndicator: showTypingIndicator }),
                React.createElement(Composer, { disabled: isReplying, onSend: onSend, ref: composerRef }))))));
};
